import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const ConseilCta = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="relative py-24 px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20interior%20design%20consultation%20meeting%20elegant%20studio%20workspace%20Abidjan%20Africa%20designer%20moodboard%20fabric%20samples%20warm%20ambient%20lighting%20professional%20creative&width=1920&height=600&seq=evco_conscta001&orientation=landscape"
          alt="Consultation design"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-brand-anthracite/75" />
      </div>

      <div
        ref={ref}
        className={`relative z-10 max-w-3xl mx-auto text-center transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="inline-flex items-center gap-2 mb-6">
          <span className="h-px w-6 bg-brand-gold" />
          <span className="text-brand-gold text-xs font-medium tracking-[0.2em] uppercase">
            Prenons rendez-vous
          </span>
          <span className="h-px w-6 bg-brand-gold" />
        </div>
        <h2 className="font-serif text-4xl lg:text-5xl text-white leading-tight mb-6">
          Prenez rendez-vous pour{' '}
          <em className="text-brand-coral">votre conseil</em>
        </h2>
        <p className="text-white/80 text-lg mb-8 leading-relaxed">
          Un service premium accessible à tous. Repartez avec des conseils concrets et actionnables pour sublimer votre espace.
        </p>

        {/* Price callout */}
        <div className="inline-block bg-white/10 backdrop-blur-sm rounded-2xl px-8 py-5 mb-10 border border-white/20">
          <p className="text-white/70 text-sm mb-1">Consultation à partir de</p>
          <p className="font-serif text-4xl font-bold text-white">30 000 XOF</p>
          <p className="text-white/60 text-xs mt-1">Déduit du devis si projet confirmé</p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="mailto:hello@evcodesign-ci.com"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-medium text-sm whitespace-nowrap transition-all duration-300 hover:scale-105"
            style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
          >
            <i className="ri-calendar-event-line" />
            Prendre rendez-vous
          </a>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/40 text-white font-medium text-sm whitespace-nowrap transition-all duration-300 hover:bg-white/10"
          >
            <i className="ri-arrow-left-line" />
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ConseilCta;
